import React, { useRef, useCallback, useEffect } from 'react';
import { VideoWrapper, VideoEmbed as StyledVideoEmbed, Iframe } from './wrappers';

interface IVideoEmbed {
  id: string;
  title?: string;
  autoplay?: boolean;
}

const VideoEmbed: React.FC<IVideoEmbed> = ({ id, title, autoplay }) => {
  const videoRef = useRef<HTMLIFrameElement>(null);

  const stopVideo = useCallback(() => {
    if (videoRef?.current) {
      videoRef.current.src = '';
      videoRef.current.src = `https://www.youtube.com/embed/${id}?rel=0&autoplay=${autoplay ? '1' : '0'}`;
    }
  }, [autoplay, id]);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) {
        stopVideo();
      }
    });
    if (videoRef?.current) {
      observer.observe(videoRef.current);
    }
    return () => {
      if (videoRef?.current) {
        observer.unobserve(videoRef?.current);
      }
    };
  }, [stopVideo]);

  return (
    <VideoWrapper>
      <StyledVideoEmbed>
        <Iframe
          ref={videoRef}
          src={`https://www.youtube.com/embed/${id}?rel=0&autoplay=${autoplay ? '1' : '0'}`}
          title={title}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
      </StyledVideoEmbed>
    </VideoWrapper>
  );
};

export default VideoEmbed;
